// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'rolememberships'

/**
 * RoleMembership Model Interface (auto-generated from Drizzle schema)
 */
export interface RoleMembershipModel {
  id: string
  orgId: string
  workspaceId?: string
  userId: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  roleId: string
  grantedBy: string
  scopeType: string
  scopeId: string
  status: string
  expiresAt: string
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "roleId": {
          "type": "string",
          "maxLength": 100
      },
      "grantedBy": {
          "type": "string",
          "maxLength": 200
      },
      "scopeType": {
          "type": "string",
          "maxLength": 200
      },
      "scopeId": {
          "type": "string",
          "maxLength": 100
      },
      "status": {
          "type": "string",
          "maxLength": 50,
          "default": "active"
      },
      "expiresAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "roleId",
      "grantedBy",
      "status",
      "userId",
      "scopeType",
      "scopeId",
      "expiresAt"
  ],
  indexes: [
      [
          "orgId",
          "userId"
      ],
      [
          "orgId",
          "roleId"
      ],
      [
          "userId",
          "orgId",
          "createdAt"
      ],
      [
          "orgId",
          "userId",
          "scopeType",
          "scopeId"
      ],
      [
          "expiresAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
